import { graphql, useStaticQuery } from "gatsby"

export const useConfig = () => {

  const data = useStaticQuery(graphql`
    {
      freshChatNodes: allConfigJson(filter: {name: {eq: "freshchat"}}, limit:1) {
        nodes {
          value {
            host
            siteId
            widgetUuid
            token
            firstName
            open
            config {
              eagerLoad
              headerProperty {
                backgroundColor
                borderColor
                foregroundColor
              }
            }
          }
        }
      },
      googleAnalyticsNodes: allConfigJson(filter: {name: {eq: "google-analytics"}}, limit:1) {
        nodes {
          value {
            id
            ga4_measurement_id 
          }
        }
      },
      googleReCaptchaNodes: allConfigJson(filter: {name: {eq: "google-recaptcha"}}, limit:1) {
        nodes {
          value {
            site_key
          }
        }
      },
      clearoutNodes: allConfigJson(filter: {name: {eq: "clearout"}}, limit:1) {
        nodes {
          value {
            api {
              baseurl
              public_email_verify,
              public_email_finder,
              public_domain_search,
              public_products,
              public_compare_products,
              public_email_list_cleaning
            },
            chrome_extension {
              downloadUrl
              fileName
            },
            app {
              baseUrl,
              registerUrl,
              loginUrl
            }
          }
        }
      }
    }
  `)

  return {
    freshchat: data.freshChatNodes.nodes[0].value,
    googleAnalytics: data.googleAnalyticsNodes.nodes[0].value,
    googleReCaptcha: data.googleReCaptchaNodes.nodes[0].value,
    clearout: data.clearoutNodes.nodes[0].value,
  }
}